import { Component, EventEmitter, Input, Output } from "@angular/core";
import { CommonModule } from "@angular/common";
import { PrimeNGSharedModule } from "@shared/prime/prime-ng.module";

@Component({
  selector: "app-draft-popup",
  standalone: true,
  imports: [CommonModule, PrimeNGSharedModule],
  templateUrl: "./draft-popup.component.html",
  styleUrls: ["./draft-popup.component.scss"],
})
export class DraftPopupComponent {
  @Input() visible: boolean = false;
  @Input() data: {
    title: string;
  } = {
    title: "",
  };

  @Output() visibleChange = new EventEmitter<boolean>();
  @Output() cancel = new EventEmitter<void>();
  @Output() confirm = new EventEmitter<void>();
  @Output() navigateToDraft = new EventEmitter<void>();

  onCancel(): void {
    this.cancel.emit();
    this.visibleChange.emit(false);
  }

  onConfirm(): void {
    this.confirm.emit();
    this.visibleChange.emit(false);
    this.navigateToDraft.emit();
  }
}
